import styled from "@emotion/styled";
import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { ApplicationState } from "@app/modules/app.reducers";
import ConnectedTable from "@ea/shared_components/Table/ConnectedTable";

import CommandBar from "./components/StorageCommandBar";
import { STORAGE_COLUMNS, STORAGE_TABLES_CONFIG } from "@app/modules/storage/storage.table";
import { storageActions, getStorageTableActions } from "@app/modules/storage/storage.actions";
import { storageDataSelectors } from "@app/modules/storage/storage.selectors";
import CreateEditStorageContainer from "@app/modules/storage/CreateEditStorage.container";

interface IStorageTableProps {}

interface IStorageTableState {
  createWindowVisibility: boolean;
  editWindowVisibility: boolean;
}

const Container = styled.div({
  display: "flex",
  flex: 1,
  flexDirection: "column",
});

class StorageTableContainer extends React.Component<
  IStorageTableProps & IConnectProps,
  IStorageTableState
> {
  connectedTable: any;

  state = {
    createWindowVisibility: false,
    editWindowVisibility: false,
  };

  openEditWindow = () => {
    this.setState({
      editWindowVisibility: true,
    });
  };

  closeEditWindow = () => {
    if (this.props.selectedStorage) {
      this.props.actions.loadSingle({ id: this.props.selectedStorage.id });
    }
    this.setState({
      editWindowVisibility: false,
    });
  };

  openCreateWindow = () => {
    this.setState({
      createWindowVisibility: true,
    });
  };

  closeCreateWindow = () => {
    this.setState({
      createWindowVisibility: false,
    });
  };

  reload = () => {
    if (this.connectedTable && this.connectedTable.reload) {
      this.connectedTable.reload();
    }
  };

  remove = () => {
    this.props.actions.delete({ ids: this.props.selected });
  };

  render() {
    return (
      <Container>
        <CommandBar
          onNewClick={this.openCreateWindow}
          onRemoveClick={this.remove}
          selected={this.props.selected}
          onEditClick={this.openEditWindow}
          onReload={this.reload}
        />
        <CreateEditStorageContainer
          visibility={this.state.createWindowVisibility || this.state.editWindowVisibility}
          onClose={this.state.editWindowVisibility ? this.closeEditWindow : this.closeCreateWindow}
          onCreate={this.reload}
          selected={this.props.selectedStorage}
          isEdit={this.state.editWindowVisibility}
        />
        <ConnectedTable
          setRef={(component) => (this.connectedTable = component)}
          pageable
          columnsConfig={STORAGE_COLUMNS}
          tableId={STORAGE_TABLES_CONFIG.MAIN.id()}
          preferencesId={STORAGE_TABLES_CONFIG.MAIN.preferencesId}
          stateKey={"storage"}
          tableActions={getStorageTableActions}
        />
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: {
    ...bindActionCreators(storageActions, dispatch),
    ...bindActionCreators(getStorageTableActions(STORAGE_TABLES_CONFIG.MAIN.id()), dispatch),
  },
});

const connectCreator = connect(
  (state: ApplicationState) => ({
    selected: storageDataSelectors.getSelectedSelector(state, STORAGE_TABLES_CONFIG.MAIN.id()),
    selectedStorage: storageDataSelectors.getSelectedItemSelector(
      state,
      STORAGE_TABLES_CONFIG.MAIN.id(),
    ),
  }),
  mapDispatchToProps,
);

type IConnectProps = ConnectedProps<typeof connectCreator>;

export default connectCreator(StorageTableContainer);
